<template>
    <div>
        <Card>
            <p slot="title">
                Histori Potongan
            </p>

            <Row type="flex" justify="space-between" align="middle"  class="code-row-bg">

                <Col span="5">
                    <Select v-model="searchSelectDepartement"
                        placeholder="Dept. Item"
                        >
                        <Option v-for="dept in departements" :value="dept.id" :key="dept">
                            {{ dept.deptName }}
                        </Option>
                    </Select>
                </Col>
                <Col span="5">
                    <DatePicker
                        v-model="dateFromTo"
                        type="daterange"
                        split-panels placeholder="Select date"
                        ></DatePicker>
                </Col>
                <Col span="3">
                    <i-switch size="large" v-model="isOnlyBca"
                        v-show="markingIdSelected != '' || dateFromTo[0] != null">
                        <span slot="open">BCA</span>
                        <span slot="close">All</span>
                    </i-switch>
                </Col>

                <Col span="3">
                    <Button
                        v-show=" showSearchButton() "
                        type="primary"
                        :loading="loadingSearch"
                        @click="getPayment"
                        icon="ios-search" >
                            <span v-if="!loadingSearch">Cari</span>
                            <span v-else>Wait.....</span>
                    </Button>
                </Col>

            </Row>
            <br/>
            <template
                v-if="payments.length > 0">
                <Tag color="green">Total : Rp {{ total | numberFormatted }}</Tag>
                <Tag color="blue" v-if="totalPayment > 0">Pembayaran : Rp {{ totalPayment | numberFormatted }}</Tag>

                <vue-csv-downloader
                    v-if="totalDiscount> 0"
                    :data="paymentsDiscCsv"
                    :fields="fieldCsv"
                    :download-name="csvName">
                    &nbsp;
                    <Tag color="red" >Potongan : Rp {{ totalDiscount | numberFormatted }}</Tag>
                </vue-csv-downloader>

                <br><br>
                <Table
                    :columns="tableColumns"
                    :data="payments"
                    no-data-text=""
                    ref="table"></Table>

            </template>
        </Card>

    </div>
</template>

<script>
import {HTTP} from '@/components/http-lib'
import _ from 'lodash'
import moment from 'moment'
import VueCsvDownloader from 'vue-csv-downloader';

const numeral = require('numeral');

export default {
    data: () => ({
        markingIdSelected : '',
        optionMarkings : [],
        csvName : 'Potongan.csv',
        loadingGetMarking: false,
        loadingSearch : false,
        isOnlyBca : false,
        payments : [],
        paymentsDiscCsv : [],
        fieldRawCsv: ['paymentDate', 'markingheadercode', 'deptNames', 'description', 'creditAmount'],
        fieldCsv: ['tanggal', 'marking', 'divisi', 'partai', 'potongan'],
        totalPayment : 0,
        dateFromTo : [],
        subbranchcode: localStorage.getItem('user.subbranchcode'),
        searchSelectDepartement : '',
        departements : '',
        tableColumns: [
            {
                type: 'index',
                width: 60,
                align: 'center'
            },
            {
                title: 'Tgl',
                key: 'paymentDate',
                width: 120,
                sortable: false
            },
            {
                title: 'Marking',
                key: 'markingheadercode',
                width: 120,
                sortable: true
            },
            {
                title: 'Kategori',
                key: 'categoryLabel',
                width: 110,
                type: 'html',
                sortable: true
            },
            {
                title: 'Jumlah',
                align : 'right',
                width: 120,
                key: 'creditAmount',
                sortable: false
            },
            // {
            //     title: 'User',
            //     align : 'left',
            //     key: 'createdby',
            //     sortable: true
            // },
            {
                title: 'Detail',
                type: 'html',
                width: 450,
                align : 'left',
                key: 'descriptionDetail',
                sortable: false
            }


        ],
        filterInput : '',
        totalDiscount: 0,
        total: 0,

    }),
    components: {
        VueCsvDownloader,
    },

    methods: {
        generateCsvName: function(dateFrom, dateTo){
            let csvName = 'Potongan '
            csvName += (dateFrom == dateTo) ? dateFrom : dateFrom + ' ' + dateTo
            csvName += '.csv'
            return csvName;
        },
        getPayment: function(){

            this.loadingSearch = true;
            let dateCreateFrom =  moment(this.dateFromTo[0], 'YYYY-MM-DD', true)
            let dateCreateTo =  moment(this.dateFromTo[1], 'YYYY-MM-DD', true)

            let dateCreateFromValid = dateCreateFrom.isValid() == false ?  '' : dateCreateFrom.format("YYYY-MM-DD");
            let dateCreateToValid = dateCreateTo.isValid() == false ?  '' : dateCreateTo.format("YYYY-MM-DD");

            this.csvName = this.generateCsvName(dateCreateFromValid, dateCreateToValid)

            HTTP
            .post('payment/discount-history', {
                itemDeptId: this.searchSelectDepartement,
                dateCreateFrom: dateCreateFromValid,
                dateCreateTo: dateCreateToValid,
                category: 'disc'
            })
            .then(response => {
                let parent = this;

                parent.totalPayment = 0
                parent.totalDiscount = 0
                parent.total = 0

                let payments = []
                _.forEach(response.data, function(value) {
                let isShow = true;

                if(parent.isOnlyBca){
                    if(_.includes(value.receivable.description, 'BCA')){
                        isShow = true
                    } else {
                        isShow = false
                    }
                }

                if(isShow){
                    console.log('---------')
                    console.log(value.id)
                    console.log(value.markingHeaderId)
                    console.log('value.payment_allocate size = ' + value.payment_allocate.length)


                    let invoiceDetails = '';
                    let deptNames = []
                    _.forEach(value.payment_allocate, function(payAllocate) {

                        if(payAllocate.invoice_due.receivable != null){
                            let paymentSum = payAllocate.invoice_due.paymentSum
                            paymentSum = numeral(paymentSum).format('0,0')

                            let deptName = ""
                            if(payAllocate.invoice_due.receivable.invoice != null){
                                deptName = payAllocate.invoice_due.receivable.invoice.item_dept.deptName
                            }

                            deptNames.push(deptName)
                            let invoiceDetail = "- " + deptName
                            invoiceDetail += " - " + payAllocate.invoice_due.receivable.description + " - Rp " + paymentSum
                            invoiceDetails += invoiceDetail + " <br/>"
                        }
                    });

                    let description = value.receivable.description
                    let descriptionDetail = '<span class="bold">' + description + '</span><hr/>' + invoiceDetails

                    var categoryLabel = '';
                    if(value.category == 'pay') {
                        categoryLabel = 'Pembayaran';
                        parent.totalPayment += value.receivable.creditAmount;
                    } else if(value.category == 'disc') {
                        categoryLabel = '<span class="red">Potongan</span>';
                        parent.totalDiscount += parseInt(value.receivable.creditAmount);
                        descriptionDetail = '<span class="bold red">' + description + '</span><hr/><span class="red">' + invoiceDetails + '</span>'
                    }

                    categoryLabel = categoryLabel + '<br/><i>' + value.createdby + '</i>'

                    let deptNamesUnique = _.uniqWith(deptNames, _.isEqual);


                    let payment = {
                        paymentDate : parent.showDateFormatted(value.paymentDate),
                        markingHeaderId : value.markingHeaderId,
                        markingheadercode : value.receivable.marking_minified.markingheadercode,
                        descriptionDetail : descriptionDetail,
                        description : description,
                        creditAmount : numeral(value.receivable.creditAmount).format('0,0'),
                        categoryLabel : categoryLabel,
                        category : value.category,
                        createdby : value.createdby,
                        deptNames : deptNamesUnique
                    }

                    parent.total += parseInt(value.receivable.creditAmount);
                    payments.push(payment);
                }

                });
                this.payments =  payments;
                this.loadingSearch = false;

                this.paymentsDiscCsv = _.chain(payments)
                    .filter(function(payment) { return payment.category == 'disc'; })
                    .map(function(object) { return _.pick(object, parent.fieldRawCsv);})
                    .value();

                this.paymentsDiscCsv = this.paymentsDiscCsv.map(function(o) {
                    return Object.assign({
                        tanggal: o.paymentDate,
                        marking: o.markingheadercode,
                        divisi: o.deptNames,
                        partai: o.description,
                        potongan: o.creditAmount
                    }, _.omit(o, 'paymentDate', 'markingheadercode', 'deptNames', 'description', 'creditAmount'));
                });

                //this.totalPayment = numeral(value.receivable.creditAmount).format('0,0')

                if(payments.length == 0){
                    this.$Notice.warning({
                        title: 'Pembayaran Tidak Ditemukan',
                        desc: ''
                    });
                }



            })
            .catch(e => {
                this.loadingSearch = false;
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            })
        },
        getMarkingByCode: _.debounce(
            function (query) {

                if (query !== '') {
                    this.loadingGetMarking = true;
                    HTTP
                    .post('marking/getBySnapshot', {
                        markingHeaderId: query,
                        subbranchcode: this.subbranchcode
                    })
                    .then(response => {

                        this.invoiceDues = []
                        this.amountResidue = ''
                        this.amountReceived = ''
                        this.description = ''

                        this.loadingGetMarking = false;
                        let data = response.data;

                        const list = data.map(item => {
                            return {
                                value: item.markingheaderid,
                                label: item.markingheadercode
                            };
                        });

                        this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                    })
                    .catch(e => {
                        this.loadingGetMarking = false;
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
                } else {
                    this.optionMarkings = [];
                }
            }, 400
        ),
        showDateFormatted : function(stringToFormat){
            let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
            return moment(dateToFormat).format("DD MMM YYYY")
        },
        showSearchButton: function(){
            // marking diisi atau tanggal diisi
            if ((this.markingIdSelected != '')  ||  ((this.dateFromTo[0] != '' && this.dateFromTo[0] != null))){
                return true
            }
            return false
        },
        getDepartement: function(){
            HTTP
            .get('itemDept')
            .then(response => {
                this.departements = response.data
            })
            .catch(e => {
                //console.log(e);
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            })
        },
    },
     created() {
      this.getDepartement();
    }
}

</script>
<style>
    .bold {
        font-weight: bold;
    }
    .red {
        color: red;
    }
</style>



// WEBPACK FOOTER //
// PaymentDiscountList.vue?3ad20865